import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import { useParams } from 'react-router-dom';
import DataTable from './DataTable';

const FloorPage = () => {
  const { floorId } = useParams();
  const floorName = "Parking -1"; // This should come from your data source

  return (
    <Panel
      header={
        <>
          <h3 className="title">{floorName}</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Flex Office</Breadcrumb.Item>
            <Breadcrumb.Item href="/office-workSpaces">Work Spaces</Breadcrumb.Item>
            <Breadcrumb.Item active>{floorName}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default FloorPage;